import type { Styles } from '@adornis/ass/style.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../theme/d-icon.js';
import '../theme/d-tooltip.js';

@customElement('component-icon-button')
export class ComponentIconButton extends ChemistryLitElement {
  @property({ attribute: 'color', type: String }) color = '#fff';
  @property({ attribute: 'background', type: String }) background = this.colors.accent.string;
  @property({ attribute: 'icon', type: String }) icon: Maybe<string>;
  @property({ attribute: 'tooltip', type: String }) tooltip: Maybe<string>;
  @property({ attribute: 'href', type: String }) href: Maybe<string>;
  @property({ attribute: 'solid', type: Boolean }) solid = false;

  override render() {
    const icon = html`
      <d-icon
        solid=${this.solid}
        ${css({
          cursor: 'pointer',
          fontSize: '24px',
          color: this.color,
          background: this.background,
          padding: '8px',
          borderRadius: '4px',
          alignSelf: this.getAttribute('align-self') || '',
          userSelect: 'none',
        })}
      >
        <!-- tooltip -->
        ${this.tooltip ? html` <d-tooltip> ${this.tooltip} </d-tooltip> ` : nothing}
        <!-- icon -->
        ${this.icon}
      </d-icon>
    `;

    if (!this.href) return icon;

    return html` <d-link href=${this.href} ${css({ textDecoration: 'none' })}> ${icon} </d-link> `;
  }
  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          display: 'contents',
        },
      },
    ] as Styles[];
  }
}
